import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import service from '../Services/service';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { CreateUserRowPermission } from '../Helper/PermissionHelper';
import { AddScreensInGroup,GetByGroupId } from '../Helper/GroupHelper';

const AddUserModal = ({ show, handleClose, rowId, groupName }) => {
    const [user, setuser] = useState([]);
    // const [selecteduser, setselecteduser] = useState(null);
    const [selecteduser, setselecteduser] = useState([]);
    const [permissions, setPermissions] = useState({
        canView: false,
        canEdit: false,
        canDelete: false,
        canAssign: false
    });

    useEffect(() => {
        if (show) {
            //  setModulename();
            fetchUsers();
            //  resetState();
            fetchSelectedUsers();
        }
    }, [show]);

    // const setModulename = () => {
    //     const moduleMap = {
    //         1: 'Layout',
    //         2: 'Screen',
    //         3: 'User',
    //         4: 'Campaign',
    //         5: 'Schedule',
    //         6: 'Content',
    //         7: 'Group',
    //         8: 'Permission',
    //     };
    //     const name = moduleMap[moduleId];
    //     if (name) setModuleName(name);
    // };

    const fetchUsers = async () => {
        var userId = localStorage.getItem("userId")
        try {
            const response = await service.getdata('User/GetAll?sortBy=Name&sortDescending=false&pageNumber=1&pageSize=1000&userId=' + userId);
            if (response?.data?.items) {
                setuser(response.data.items);
            }
        } catch (error) {
            toast.error('Failed to fetch users.');
        }
    };

    const fetchSelectedUsers = async () => {
        try {
            const res = await GetByGroupId(rowId);
            if (res !== undefined) {
                const selecteduserIds = res.map(item => item.userId);
                setselecteduser(selecteduserIds);
            }
        } catch (error) {
            toast.error("Failed to fetch selected displays.");
        }
    };

    // const resetState = () => {
    //     setSelectedUser(null);
    //     setPermissions({
    //         canView: false,
    //         canEdit: false,
    //         canDelete: false,
    //         canAssign: false
    //     });
    // };

    const userOptions = user.map((s) => ({
        value: s.userId,
        label: `${s.username} (${s.firstName} ${s.lastName})`,
    }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!selecteduser) {
            toast.error("Please Add a Display first.");
            return;
        }

        const userId = parseInt(localStorage.getItem("userId"));
        const currentTimestamp = new Date().toISOString();

        const payload = selecteduser.map(u => ({
            groupScreenId: 0,
            groupId: rowId, // Assuming rowId is the groupId from parent
            screenId: 0,
            userId: u, // or set this if userId is to be passed from selection
            permissionId: 0,
            contentId: 0,
            layoutId: 0,
            createdBy: userId,
            updatedBy: userId,
            createdAt: currentTimestamp,
            updatedAt: currentTimestamp
        }));

        try {
            const res = await AddScreensInGroup(payload);
            if (res !== undefined) {
                toast.success('Display Add created successfully!');
                handleClose();
            } else {
                toast.error('Failed to Add Display. Please try again!');
            }
        } catch (error) {
            toast.error('An error occurred while Adding the Display.');
        }
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered>
            <form onSubmit={handleSubmit}>
                <Modal.Header className="border-bottom">
                    <Modal.Title className="w-100 text-center">
                        Add Displays - {groupName}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <div className="form-group">
                        <label className="font-weight-bold">Select User</label>
                        <Select
                            options={userOptions}
                            isMulti
                            value={userOptions.filter(option => selecteduser.includes(option.value))}
                            onChange={(selectedOptions) => {
                                const selectedValues = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
                                setselecteduser(selectedValues);
                            }}
                            placeholder="Search and select users"
                        />
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => {
                        //  resetState();
                        handleClose();
                    }}>
                        Cancel
                    </Button>
                    <Button type="submit" variant="success">
                        Add
                    </Button>
                </Modal.Footer>
            </form>
        </Modal>
    );
};

export default AddUserModal;
